import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, ExpenseVouchersController, ExpenseVouchersRequest, BillHeaderWithItemsController, BillHeaderWithItemsRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, RefundDetailsData, RefundDetailsRequest, RefundItemDetailsController, IahOrderItemsController, IahOrderItemsRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { NgxSpinnerService } from 'ngx-spinner';




@Component({
  selector: 'iohvieworderPV',
  templateUrl: './iohvieworderPV.component.html',
  styleUrls: ['./iohvieworderPV.component.scss']
})

export class IohvieworderPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public IahOrderCode: any;
  public TotalAmount: any;
  public Date: Date;
  public Gender: any;
  public CustomerName: any;
  public AgeY: any;
  public MobileNumber: any; 
  public DeliverToAddress: any;
  public FormattedCode: any;
  public OrderDate: any;
  public OrderNo: any;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public ItemsData: boolean = false;
  //pdata: any[];
  pdata: any[];


  CurrentIahOrderItemsController: IahOrderItemsController[];
  CurrentIahOrderItemsRequest: IahOrderItemsRequest;
  LoadPatients2() {
    this.CurrentIahOrderItemsRequest = new IahOrderItemsRequest();

    // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


    this.CurrentIahOrderItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentIahOrderItemsController;

    this.GetIahOrderItemsController();
  }

  GetIahOrderItemsController() {
    this.StartRefreshing();
    this.CurrentIahOrderItemsRequest.ConditionalOperator = 10;
    this.CurrentIahOrderItemsRequest.IahOrderCode = this.IahOrderCode;
    //this.CurrentIahOrderItemsRequest.ActorCode = this.CActorCode;


    this.actorservice.GetIahOrderItemsController(this.CurrentIahOrderItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIahOrderItemsController = this.ApiResData.Result;
          this.pdata = this.CurrentIahOrderItemsController;
          this.stopRefreshing();
          this.LoadOqaData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;
  OocyteStorageDetails: IvfOocyteEmbryoStorageByCodeController;
  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    //this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    //this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;


          this.stopRefreshing();
          this.printService.onDataReady();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();
    this.IahOrderCode = this.route.snapshot.paramMap.get('IahOrderCodeData');
    this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCode');
    this.TotalAmount = this.route.snapshot.paramMap.get('TotalAmount');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.CustomerName = this.route.snapshot.paramMap.get('CustomerName');
    this.AgeY = this.route.snapshot.paramMap.get('AgeY');
    this.MobileNumber = this.route.snapshot.paramMap.get('MobileNumber');
    this.DeliverToAddress = this.route.snapshot.paramMap.get('DeliverToAddress');
    this.OrderDate = this.route.snapshot.paramMap.get('OrderDate');
    this.OrderNo = this.route.snapshot.paramMap.get('OrderNo');
    this.LoadPatients2();
  

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
